import { configureStore } from '@reduxjs/toolkit';
import commonReducer from './common/slice';
import contentReducer from './content/slice';
import homeReducer from './home/slice';
import projectReducer from './project/slice';
import searchReducer from './search/slice';
import { createWrapper } from 'next-redux-wrapper';

const rootReducer = {
  common: commonReducer,
  home: homeReducer,
  search: searchReducer,
  project: projectReducer,
  content: contentReducer,
};

export const makeStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

export const wrapper = createWrapper<ReturnType<typeof makeStore>>(makeStore, {
  debug: process.env.NODE_ENV !== 'production',
});
